import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as CommunityContextConsumer } from '../../../contexts/CommunityContext';
import AuthWrapperComponent from '../../CallToAction/AuthWrapperComponent/AuthWrapperComponent';
import { FullSingleTopicProps } from '../../Includes/TopicPropsShape';
import Button from '../../Input/Button/Button';
import './TopicSubscribeButton.scss';

export default class TopicSubscribeButton extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            subscribed: this.subscribeCheck(props),
        };
    }

    static propTypes = {
        /**
         * topic object
         */
        topic: PropTypes.shape(FullSingleTopicProps),
        /**
         * user object.
         */
        user: PropTypes.object.isRequired,
        onClick: PropTypes.func,
    };

    subscribeCheck = (props) => {
        if (props.user.subscribedTopics) {
            const subscribedTopicIds = props.user.subscribedTopics.map(
                (topic) => topic.id
            );
            return subscribedTopicIds.includes(props.topic.id);
        }
        return false;
    };

    handleSubscribeState = () => {
        this.setState({
            subscribed: true,
        });
    };

    render() {
        let buttonText = 'Subscribe';
        let buttonClass = 'secondary-blue-gray';
        let buttonDisabled = false;
        if (this.state.subscribed) {
            buttonText = 'Subscribed';
            buttonClass = 'primary-blue-gray';
            buttonDisabled = true;
        }
        return (
            <div className="component-Community-TopicSubscribeButton">
                <CommunityContextConsumer>
                    {(CommunityContext) => (
                        <div className="call-to-actions">
                            <div className="button-div">
                                <AuthWrapperComponent
                                    callToActionHash={'subscribe-to-topic'}
                                    loginTrigger={'subscribe-to-topic'}
                                >
                                    <Button
                                        type={buttonClass}
                                        disabled={buttonDisabled}
                                        value={buttonText}
                                        onClick={() =>
                                            CommunityContext.subscribeToTopic(
                                                this.props.topic.id,
                                                this.handleSubscribeState
                                            )
                                        }
                                    />
                                </AuthWrapperComponent>
                            </div>
                        </div>
                    )}
                </CommunityContextConsumer>
            </div>
        );
    }
}
